module.exports = __webpack_public_path__ + "static/media/product_coffee.168bf851.png";